import { LifeBuoy, Flame, Radio, AlertTriangle, Shield, Users } from 'lucide-react';

export const mockEquipment = [
  {
    id: 1,
    name: 'Liferaft #1 (Port)',
    type: 'LSA',
    status: 'overdue',
    nextService: '15 days ago',
    icon: LifeBuoy,
  },
  {
    id: 2,
    name: 'Fire Extinguisher CO2',
    type: 'FFE',
    status: 'due_soon',
    nextService: '5 days',
    icon: Flame,
  },
  {
    id: 3,
    name: 'EPIRB',
    type: 'NAV',
    status: 'compliant',
    nextService: '90 days',
    icon: Radio,
  },
  {
    id: 4,
    name: 'Liferaft #2 (Starboard)',
    type: 'LSA',
    status: 'compliant',
    nextService: '120 days',
    icon: LifeBuoy,
  },
  {
    id: 5,
    name: 'Emergency Fire Pump',
    type: 'FFE',
    status: 'overdue',
    nextService: '3 days ago',
    icon: Flame,
  },
  {
    id: 6,
    name: 'VHF Radio',
    type: 'COMM',
    status: 'compliant',
    nextService: '60 days',
    icon: Radio,
  },
];

export const mockStats = [
  {
    icon: Shield,
    title: 'Drills',                      // MIDDLE: Bold, 20px, dark navy
    message: 'Fire drill overdue',        // BOTTOM: Normal, 14px, red
    status: 'overdue',
    // Legacy fallback fields
    label: 'Drills',
    value: 'Fire drill overdue',
  },
  {
    icon: AlertTriangle,
    title: 'Defects',                     // MIDDLE: Bold, 20px, dark navy
    message: '3 open defects',            // BOTTOM: Normal, 14px, amber
    status: 'warning',
    // Legacy fallback fields
    label: 'Defects',
    value: '3 open defects',
  },
  {
    icon: LifeBuoy,
    title: 'Equipment',                   // MIDDLE: Bold, 20px, dark navy
    message: '2 items overdue',           // BOTTOM: Normal, 14px, red
    status: 'overdue',
    // Legacy fallback fields
    label: 'Equipment',
    value: '2 items overdue',
  },
  {
    icon: Users,
    title: 'Crew',                        // MIDDLE: Bold, 20px, dark navy
    message: 'All 8 crew active',         // BOTTOM: Normal, 14px, green
    status: 'compliant',
    // Legacy fallback fields
    label: 'Crew',
    value: 'All 8 crew active',
  },
];
